import { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { UserContext } from '../UserContext'
import { getOwnedTreesForUser } from '../../../services/userService'
import useNotifications from '../../../hooks/useNotifications'
import { getPersonCount } from '../../../services/treeService'

export default function useUserOwnedTrees() {
  const userContext = useContext(UserContext)
  const [ownedTrees, setOwnedTrees] = useState([])
  const { error } = useNotifications()
  const { t } = useTranslation()

  useEffect(() => {
    const applyPersonCount = async (ownedTree) => {
      const personCount = await getPersonCount(ownedTree.tree.treeId).catch((err) => {
        error(
          t('tree.error.personCount', 'Error getting persons count for tree {treeId}: {message}', {
            treeId: ownedTree.tree.treeId,
            message: err.message,
          })
        )
      })
      ownedTree.tree.personCount = personCount.data
    }

    userContext?.currentUser?.dmcUser?.cisId &&
      getOwnedTreesForUser(userContext.currentUser.dmcUser.cisId)
        .then(async (response) => {
          await Promise.allSettled(
            response.data.map(async (ownedTree) => {
              await applyPersonCount(ownedTree)
              return ownedTree
            })
          )
          setOwnedTrees(response.data)
        })
        .catch((err) => {
          error(
            t('user.tree.errors.getOwnedTrees', `Error getting trees owned by this user - {message}`, {
              message: err.message || '',
            })
          )
        })
  }, [error, t, userContext.currentUser.dmcUser.cisId])

  return { ownedTrees }
}
